import { FC } from "react";

export const HeaderAvatar: FC = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#E5F2FF" />
    <mask
      id="mask0_262_282758"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <circle cx="16" cy="16" r="16" fill="#E5F2FF" />
    </mask>
    <g mask="url(#mask0_262_282758)">
      <path
        d="M15.9993 19.9997C19.221 19.9997 21.8327 17.388 21.8327 14.1663C21.8327 10.9447 19.221 8.33301 15.9993 8.33301C12.7777 8.33301 10.166 10.9447 10.166 14.1663C10.166 17.388 12.7777 19.9997 15.9993 19.9997Z"
        fill="#99CAFE"
      />
      <path
        d="M15.9995 22.917C10.1545 22.917 5.39453 26.837 5.39453 31.667C5.39453 31.9937 5.6512 32.2503 5.97786 32.2503H26.0212C26.3479 32.2503 26.6045 31.9937 26.6045 31.667C26.6045 26.837 21.8445 22.917 15.9995 22.917Z"
        fill="#007BFB"
      />
    </g>
  </svg>
);
